export { CollectionTitleDS } from '@src/components/blocks/collection-title-ds'
export { CollectionTitle } from './CollectionTitle'
export { CollectionTitleLegacy } from './collection-title-legacy'
export type { CollectionTitleProps } from './collection-title.types'
